import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import GlobalStyles from './Styles/GlobalStyle';
import Typography from './Styles/Typography';

ReactDOM.render(
  <>
    <GlobalStyles />
    <Typography />
    <App />
  </>,
  document.getElementById('root')
);